import './styles.css';
import Header from '../header/header';
import RunningTotals from '../runningtotals/runningtotals';
import mountains from '../../assets/images/mountains.jpg'
import ImagePreview from '../image-preview/imagePreview';

function Home() {
  return (
    <div className="">
      <header>
        <Header />
      </header>

      <main>
        <section className="left-column">
          <div className="flex flex-col md:flex-row">
          <div className="w-full md:w-1/2 p-6 md:p-10 text-left">
            <div className="card--b">
              <span className="eyebrows">Welcome</span>
              </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-8">
              Hey there!
            </h2>

            <p className="text-lg md:text-xl text-white mb-4">
              Alison has always had a passion for travel, and over the years,
              she's had the opportunity to explore some of the most beautiful
              cities and towns in Europe. From the charming villages of the UK
              to the majestic peaks of the Alps, Alison has captured some truly
              stunning images on her travels.
            </p>

            <p className="text-lg md:text-xl text-white mb-4">
              This website is a place for Alison to share her favourite images
              with the world, and for you to browse through her collection of
              European adventures. Whether you're dreaming of your next European
              getaway, or simply want to admire some breathtaking scenery, you've
              come to the right place.
            </p>

            <p className="text-lg md:text-xl text-white mb-4">
              Take a look around, and discover the beauty of Europe through
              Alison's lens. And who knows — maybe you'll even be inspired to
              plan your own European adventure!
            </p>
          </div>

          <div className="w-full md:w-1/2 p-6 md:p-10 text-left">
            <img
              src={mountains}
              alt="Alison in front of a mountain range"
              className="h-full max-h-[600px] w-full rounded-2xl object-cover"
            />
          </div>
          </div>
        </section>
        
      <section className="runningStats p-6 md:p-10">
              <div className="card--a">
        <span className="eyebrows">Running statistics</span>
      </div>

      <h2 className="pb-6">Travel highlights</h2>
          <RunningTotals />
        </section>

        <section className="imagepreview p-6 md:p-10">
          <div className="card--b">
              <span className="eyebrows">A glimpse abroad</span>
              </div>
          <ImagePreview />
        </section>
      </main>
    </div>
  );
}

export default Home;